<template>
    <div class="editionmobile" @click="">
        <top_mobile></top_mobile>
        <div class="topimg">
            <img src="../../public/statics/img/mobile/editiontop.png" alt="">
        </div>
        <div class="cotain">
            <swiper :options="swiperOption" class="swiper-container"
                    ref="mySwiper" >
                <!--<swiper-slide class="swiper-slide">
                    <div class="unit " :class="vip_type==1 && editionstatus==1? 'unitboder' : '' ">
                        <p class="unit1">基础版</p>
                        <div class="unit3">
                            免费
                        </div>
                        <div class="unit5">
                            ——&nbsp;企业服务内容&nbsp;——
                        </div>
                        <div class="unit2">
                            <div class="edispan2">
                                <img src="../../public/statics/img/yes.png" alt="">
                                <span>运输单据管理(100单/月)</span>
                            </div>
                            <div class="edispan2">
                                <img src="../../public/statics/img/yes.png" alt="">
                                <span>基础数据维护</span>
                            </div>
                            <div class="edispan2">
                                <img src="../../public/statics/img/yes.png" alt="">
                                <span>运输轨迹实时监控</span>
                            </div>
                            <div class="edispan2">
                                <img src="../../public/statics/img/yes.png" alt="">
                                <span>应收应付费用管理</span>
                            </div>
                            <div class="edispan2">
                                <img src="../../public/statics/img/yes.png" alt="">
                                <span>统计分析报表</span>
                            </div>
                            <div class="edispan2">
                                <img src="../../public/statics/img/no.png" alt="">
                                <span style="color: #999999;">日常车辆调度</span>
                            </div>
                            <div class="edispan2">
                                <img src="../../public/statics/img/no.png" alt="">
                                <span style="color: #999999;">通过平台承接货主的订单</span>
                            </div>
                        </div>

                        <div class="unit4" v-show="editionstatus==0" @click="toapply(1)">立即申请</div>
                    </div>
                    <div class="unitmask"></div>
                </swiper-slide>
                <swiper-slide class="swiper-slide">
                    <div class="units" :class="vip_type==2 && editionstatus==1? 'unitsboder' : '' ">
                        <p class="unit1">专业版</p>
                        <div class="unit3">
                            <span>￥</span>
                            3.6万
                            <span>/年</span>
                        </div>
                        <div class="unit5">
                            ——&nbsp;企业服务内容&nbsp;——
                        </div>
                        <div class="unit2">
                            <div class="edispan2">
                                <img src="../../public/statics/img/yes.png" alt="">
                                <span>运输单据管理(无限制)</span>
                            </div>
                            <div class="edispan2">
                                <img src="../../public/statics/img/yes.png" alt="">
                                <span>基础数据维护</span>
                            </div>
                            <div class="edispan2">
                                <img src="../../public/statics/img/yes.png" alt="">
                                <span>运输轨迹实时监控</span>
                            </div>
                            <div class="edispan2">
                                <img src="../../public/statics/img/yes.png" alt="">
                                <span>应收应付费用管理</span>
                            </div>
                            <div class="edispan2">
                                <img src="../../public/statics/img/yes.png" alt="">
                                <span>统计分析报表</span>
                            </div>
                            <div class="edispan2">
                                <img src="../../public/statics/img/yes.png" alt="">
                                <span style="color: #CA2535;">日常车辆调度</span>
                            </div>
                            <div class="edispan2">
                                <img src="../../public/statics/img/no.png" alt="">
                                <span style="color: #999999;">通过平台承接货主的订单</span>
                            </div>
                        </div>



                        <div class="unit4" v-if="editionstatus==0" @click="toapply(2)">立即申请</div>
                        <div class="unit4" v-if="editionstatus==1 && vip_type==1 && vip_log==0 " @click="toapplys(2,1)">
                            立即升级
                        </div>
                        <div class="unit4" v-if="editionstatus==1 && vip_type==2 && vip_log==0" @click="torenew(2,2)">
                            立即续费
                        </div>
                        <div class="unit4" v-if="vip_log==4">续费中</div>
                        <div class="unit4" v-if="vip_log==2">升级中</div>

                    </div>
                    <div class="unitmask"></div>
                </swiper-slide>
                <swiper-slide class="swiper-slide">
                    <div class="unitss" :class="vip_type==3 && editionstatus==1? 'unitssboder' : '' ">
                        <p class="unit1">高级版</p>
                        <div class="unit3">
                            <span>￥</span>
                            10万
                            <span>/年</span>
                        </div>
                        <div class="unit5">
                            ——&nbsp;企业服务内容&nbsp;——
                        </div>
                        <div class="unit2">
                            <div class="edispan2">
                                <img src="../../public/statics/img/yes.png" alt="">
                                <span>运输单据管理(无限制)</span>
                            </div>
                            <div class="edispan2">
                                <img src="../../public/statics/img/yes.png" alt="">
                                <span>基础数据维护</span>
                            </div>
                            <div class="edispan2">
                                <img src="../../public/statics/img/yes.png" alt="">
                                <span>运输轨迹实时监控</span>
                            </div>
                            <div class="edispan2">
                                <img src="../../public/statics/img/yes.png" alt="">
                                <span>应收应付费用管理</span>
                            </div>
                            <div class="edispan2">
                                <img src="../../public/statics/img/yes.png" alt="">
                                <span>统计分析报表</span>
                            </div>
                            <div class="edispan2">
                                <img src="../../public/statics/img/yes.png" alt="">
                                <span style="color: #CA2535;">日常车辆调度</span>
                            </div>
                            <div class="edispan2">
                                <img src="../../public/statics/img/yes.png" alt="">
                                <span style="color: #A4642A;">通过平台承接货主的订单</span>
                            </div>
                        </div>


                        <div class="unit4" v-if="editionstatus==0" @click="toapply(3)">立即申请</div>
                        <div class="unit4"
                             v-if="editionstatus==1 && (vip_type==1 || vip_type==2) && (vip_log==0 || vip_log==2 || vip_log==4)"
                             @click="toapplys(3,1)">立即升级
                        </div>
                        <div class="unit4"
                             v-if="editionstatus==1 && vip_type==3 && (vip_log==0 || vip_log==2 || vip_log==4)"
                             @click="torenew(3,2)">立即续费
                        </div>
                        <div class="unit4" v-if="vip_log==3">升级中</div>
                        <div class="unit4" v-if="vip_log==5">续费中</div>
                    </div>
                    <div class="unitmask"></div>
                </swiper-slide>-->
                <swiper-slide class="swiper-slide">
                    <div class="change1">
                        <div class="change1s">
                            <img src="../../public/statics/img/editon/green.png" alt=""/>
                            <p class="change1sf1">INCLUSIVE</p>
                            <span class="change1sf2">IDA普惠云</span>
                        </div>
                        <div class="content1">
                            <div class="content11">
                                <p>端口报价</p>
                            </div>
                            <div class="content12">
                                <p>免费</p>
                            </div>
                        </div>
                        <div class="content2"></div>
                        <el-popover
                                placement="top-start"
                                width="150"
                                trigger="click"
                                content="适用于小规模的运输业务管理模式，满足接单、调度、跟踪、回单、对账及结算等基础运输管理。">
                            <div slot="reference" class="content3">
                                <div class="content31">
                                    <div class="content3s">
                                        <span class="content3s1">基础运输模块</span>
                                        <div style="display: flex;align-items: center;">
                                            <span class="content3s2">(必选)</span>
                                            <i class="el-icon-info" style="font-size: 14px;color:#a0de73;"></i>
                                        </div>

                                    </div>


                                </div>
                                <div class="content32">
                                    <span class="content321">￥500/月</span>
                                    <span class="content322">(￥6000/年)</span>
                                </div>
                            </div>
                        </el-popover>


                    </div>
                    <div class="unitmask"></div>
                </swiper-slide>
                <swiper-slide class="swiper-slide">
                    <div class="change1">
                        <div class="change1s">
                            <img src="../../public/statics/img/editon/blue.png" alt=""/>
                            <p class="change1sf1">TRANSPORT</p>
                            <span class="change1sf2">IDA云运输</span>
                        </div>
                        <div class="content1">
                            <div class="content11">
                                <p>端口报价</p>
                                <span>(5个起售)</span>
                            </div>
                            <div class="content12">
                                <p>￥300/月/个</p>
                                <span>(￥3600/年)</span>
                            </div>
                        </div>
                        <div class="content2"></div>
                        <el-popover
                                placement="top-start"
                                width="150"
                                trigger="click"
                                content="适用于车辆提货后直接承运干线运输的3PL调度模式，并可添加末端派送承运人。可满足所有单点及多点提送货环境下的城际、城配等汽运业务场景。">
                            <div slot="reference" class="content3">
                                <div class="content31">
                                    <div class="content3s">
                                        <span class="content3s1">直运管理模块</span>
                                        <div style="display: flex;align-items: center;">
                                            <span class="content3s2">(必选)</span>
                                            <i class="el-icon-info" style="font-size: 14px;color:#51a1de;"></i>
                                        </div>
                                    </div>
                                    <!--<el-popover
                                        placement="top-start"
                                        width="150"
                                        trigger="click"
                                        content="车辆提货后直接发运。">
                                    <i slot="reference" class="el-icon-info" style="color: #5098d1;"></i>
                                </el-popover>-->
                                </div>
                                <div class="content32">
                                    <span class="content321">￥4000/月</span>
                                    <span class="content322">(￥48000/年)</span>
                                </div>
                            </div>
                        </el-popover>
                        <el-popover
                                placement="top-start"
                                width="150"
                                trigger="click"
                                content="适用于提货车辆提货后再转交给一级或多级干线承运人发运的3PL调度模式。可满足汽运、铁运、空运、水运等所有多联式运输业务场景。">
                            <div slot="reference" class="content3">
                                <div class="content31">
                                    <div class="content3s"
                                         style="display: flex;flex-direction:revert;align-items: center;">
                                        <span class="content3s1">转运管理模块</span>
                                        <i class="el-icon-info" style="font-size: 14px;color:#51a1de;"></i>
                                    </div>
                                </div>
                                <div class="content32">
                                    <span class="content321">￥1500/月</span>
                                    <span class="content322">(￥18000/年)</span>
                                </div>
                            </div>
                        </el-popover>
                        <el-popover
                                placement="top-start"
                                width="150"
                                trigger="click"
                                content="适用于提货车辆提货后先进入3PL中转库，再重新配载发运的3LP调度模式。可满足所有需要集货中转后再自主配载发运的运输业务场景。">
                            <div slot="reference" class="content3">
                                <div class="content31">
                                    <div class="content3s"
                                         style="display: flex;flex-direction:revert;align-items: center;">
                                        <span class="content3s1">配载管理模块</span>
                                        <i class="el-icon-info" style="font-size: 14px;color:#51a1de;"></i>
                                    </div>

                                </div>
                                <div class="content32">
                                    <span class="content321">￥1500/月</span>
                                    <span class="content322">(￥18000/年)</span>
                                </div>
                            </div>
                        </el-popover>
                        <el-popover
                                placement="top-start"
                                width="150"
                                trigger="click"
                                content="运输业务中所有应收、应付费用的智能辅助录入，以及费用核对、审核、结算等财务交互功能。">
                            <div slot="reference" class="content3">
                                <div class="content31" style="display: flex;flex-direction:revert;align-items: center;">
                                    <div class="content3s"
                                         style="display: flex;flex-direction:revert;align-items: center;">
                                        <span class="content3s1">费用结算模块</span>
                                        <i class="el-icon-info" style="font-size: 14px;color:#51a1de;"></i>
                                    </div>
                                </div>
                                <div class="content32">
                                    <span class="content321">￥1000/月</span>
                                    <span class="content322">(￥12000/年)</span>
                                </div>
                            </div>
                        </el-popover>


                    </div>
                    <div class="unitmask"></div>
                </swiper-slide>
                <swiper-slide class="swiper-slide">
                    <div class="change1">
                        <div class="change1s">
                            <img src="../../public/statics/img/editon/purple.png" alt=""/>
                            <p class="change1sf1">PACKAGING</p>
                            <span class="change1sf2">IDA云包装</span>
                        </div>
                        <div class="content1">
                            <div class="content11">
                                <p>端口报价</p>
                                <span>(5个起售)</span>
                            </div>
                            <div class="content12">
                                <p>￥300/月/个</p>
                                <span>(￥3600/年)</span>
                            </div>
                        </div>
                        <div class="content2"></div>
                        <el-popover
                                placement="top-start"
                                width="150"
                                trigger="click"
                                content="通过智能硬件和终端设备，实现循环包装的货物装箱、空箱回收以及返箱调度等管理。">
                            <div slot="reference" class="content3">
                                <div class="content31">
                                    <div class="content3s">
                                        <span class="content3s1">循环管理模块</span>
                                        <div style="display: flex;align-items: center;">
                                            <span class="content3s2">(必选)</span>
                                            <i class="el-icon-info" style="font-size: 14px;color:#f7bafe;"></i>
                                        </div>
                                    </div>

                                </div>
                                <div class="content32">
                                    <span class="content321">￥5000/月</span>
                                    <span class="content322">(￥60000/年)</span>
                                </div>
                            </div>
                        </el-popover>
                        <el-popover
                                placement="top-start"
                                width="150"
                                trigger="click"
                                content="适用于循环包装的动态租赁和静态租赁业务场景，通过智能辅助功能，实现租赁过程中的合同周期、用量统计、租金计算等智能管理。">
                            <div slot="reference" class="content3">
                                <div class="content31">
                                    <div class="content3s"
                                         style="display: flex;flex-direction:revert;align-items: center;">
                                        <span class="content3s1">租赁管理模块</span>
                                        <i class="el-icon-info" style="font-size: 14px;color:#f7bafe;"></i>
                                    </div>

                                </div>
                                <div class="content32">
                                    <span class="content321">￥2000/月</span>
                                    <span class="content322">(￥24000/年)</span>
                                </div>
                            </div>
                        </el-popover>

                        <el-popover
                                placement="top-start"
                                width="150"
                                trigger="click"
                                content="实现智能辅助模式下的循环包装动态和静态库存盘点，实时掌握循环动态库存。">
                            <div slot="reference" class="content3">
                                <div class="content31">
                                    <div class="content3s"
                                         style="display: flex;flex-direction:revert;align-items: center;">
                                        <span class="content3s1">包装盘点模块</span>
                                        <i class="el-icon-info" style="font-size: 14px;color:#f7bafe;"></i>

                                    </div>

                                </div>
                                <div class="content32">
                                    <span class="content321">￥1500/月</span>
                                    <span class="content322">(￥18000/年)</span>
                                </div>
                            </div>
                        </el-popover>

                        <el-popover
                                placement="top-start"
                                width="150"
                                trigger="click"
                                content="通过智能辅助功能，对循环包装在使用过程中资产变化情况进行实时管理，并自动计算和统计折旧费用。">
                            <div slot="reference" class="content3">
                                <div class="content31">
                                    <div class="content3s"
                                         style="display: flex;flex-direction:revert;align-items: center;">
                                        <span class="content3s1">资产管理模块</span>
                                        <i class="el-icon-info" style="font-size: 14px;color:#f7bafe;"></i>
                                    </div>
                                </div>
                                <div class="content32">
                                    <span class="content321">￥1000/月</span>
                                    <span class="content322">(￥12000/年)</span>
                                </div>
                            </div>
                        </el-popover>


                    </div>
                    <div class="unitmask"></div>
                </swiper-slide>
                <swiper-slide class="swiper-slide">
                    <div class="change1">
                        <div class="change1s">
                            <img src="../../public/statics/img/editon/orange.png" alt=""/>
                            <p class="change1sf1">WAREHOUSE</p>
                            <span class="change1sf2">IDA云仓储</span>
                        </div>
                        <div class="content1">
                            <div class="content11">
                                <p>端口报价</p>
                                <span>(5个起售)</span>
                            </div>
                            <div class="content12">
                                <p>￥300/月/个</p>
                                <span>(￥3600/年)</span>
                            </div>
                        </div>
                        <div class="content2"></div>
                        <el-popover
                                placement="top-start"
                                width="150"
                                trigger="click"
                                content="支持移动终端和智能设备，无缝对接云运输系统，实现实时出入库以及库存管理，满足虚拟云仓、 VMI、CDC、RDC等仓储业务模式。">
                            <div slot="reference" class="content3">
                                <div class="content31">
                                    <div class="content3s">
                                        <span class="content3s1">
                      出入库/库位管理模块

                    </span>
                                        <div style="display: flex;align-items: center;">
                                            <span class="content3s2">(必选)</span>
                                            <i class="el-icon-info" style="font-size: 14px;color:#f9c9a0;"></i>
                                        </div>
                                    </div>

                                </div>
                                <div class="content32">
                                    <span class="content321">￥4000/月</span>
                                    <span class="content322">(￥48000/年)</span>
                                </div>
                            </div>
                        </el-popover>

                        <el-popover
                                placement="top-start"
                                width="150"
                                trigger="click"
                                content="实现智能辅助模式下的动态和静态库存盘点，实时对库存货物的账、物、卡、证进行精准核对。">
                            <div slot="reference" class="content3">
                                <div class="content31">
                                    <div class="content3s"  style="display: flex;flex-direction:revert;align-items: center;">
                                    <span class="content3s1">
                库存盘点模块

                </span> <i class="el-icon-info" style="font-size: 14px;color:#f9c9a0;"></i>
                                    </div>

                                </div>
                                <div class="content32">
                                    <span class="content321">￥1000/月</span>
                                    <span class="content322">(￥12000/年)</span>
                                </div>
                            </div>
                        </el-popover>


                    </div>
                    <div class="unitmask"></div>
                </swiper-slide>
            </swiper>
        </div>
        <!--<div class="swiper-pagination" slot="pagination"></div>-->

        <el-button type="danger" v-if="purchaseshow" class="cbuto" @click="jumppayediton('extral')">{{puhuiyun==1?'前往续费':'前往购买'}}</el-button>
        <el-button type="danger" v-if="!purchaseshow" class="cbuto" @click="jumppayediton()">前往选购</el-button>

        <van-popup v-model="dialogVisible" position="top" :style="{ height: '160px' }">
            <div style="padding: 20px">
                <div style="display: flex;align-items: center;">
                    <div
                            style="width:4px;
height:16px;
background:rgba(243,89,89,1);
border-radius:60px;margin-right: 5px;"
                    ></div>
                    <span
                            style="font-size:18px;font-family:PingFang SC;font-weight:400;color:rgba(51,51,51,1);"
                    >确定要<span v-if="editionoption==1">升级</span>
                    <span v-if="editionoption==2">续费</span>该版本吗?</span>
                </div>
                <div style="width:100%; display: flex;flex-wrap: wrap;">
                    <div style="line-height: 60px;text-align: center;width: 100%;color:#00aec2;font-size: 34px;"
                         v-if="edition==1">基础版
                    </div>
                    <div style="line-height: 60px;text-align: center;width: 100%;color:#84c024;font-size: 34px;"
                         v-if="edition==2">专业版
                    </div>
                    <div style="line-height: 60px;text-align: center;width: 100%;color:#016596;font-size: 34px;"
                         v-if="edition==3">高级版
                    </div>

                    <span style="width:100%;display: flex;justify-content: flex-end;margin-top: 10px;">
                    <el-button
                            style="width: 64px;height:30px;padding: 0;"
                            type="info"
                            @click="closedvisible()">取消</el-button>
                    <el-button
                            style="width: 64px;height:30px;padding: 0;"
                            type="primary"
                            @click="sure(edition,editionoption)">确认</el-button>
                </span>
                </div>
            </div>

        </van-popup>


        <botmob></botmob>
    </div>

</template>

<script>
    import top_mobile from "../components/top_mobile";
    import botmob from "../components/botmobile";
    import {auth, anth} from '../request/api';
    import Cookies from 'js-cookie'
    import {getToken, setToken, removeToken} from '../request/toekn'
    import {mapGetters} from "vuex";

    export default {
        name: "edition_mobile",
        components: {
            top_mobile, botmob
        },
        data() {
            const _self = this;
            return {
                swiperOption: {
                    initialSlide :1,
                    slidesPerView: 3,
                    spaceBetween: -50,
                    centeredSlides: true,
                    loop: false,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true,
                    },
                    on: {
                      slideChangeTransitionEnd: function(){
                        if (this.activeIndex==0){
                          _self.purchaseshow=true;
                        }else{
                          _self.purchaseshow=false;
                        }
                        document.body.click()
                      },
                    },
                },

                editionstatus: 0,//是否登录
                // vip_type:2,


                dialogVisible: false,
                editionoption: "",//续费或升级
                edition: "",//续费的版本

                //移动端修改购买与续费
                purchaseshow:false,
            }
        },
        computed: {
            ...mapGetters(["vip_type", "vip_log",'puhuiyun']),
        },
        mounted() {
            if (Cookies.get(getToken()) && getToken()) {
                this.editionstatus = 1;
            } else {
                this.editionstatus = 0;
            }


        },
        methods: {
            //申请注册
            toapply(e) {
                this.$router.push({
                    path: '/apply_mobile',
                    query: {vip_type: e}
                });
            },
            //升级
            toapplys(e1, e2) {
                this.edition = e1;
                this.editionoption = e2;
                this.dialogVisible = true;
            },
            //续费
            torenew(e1, e2) {
                this.edition = e1;
                this.editionoption = e2;
                this.dialogVisible = true;
            },
            //关闭续费弹窗
            closedvisible() {
                this.renewedition = '';
                this.editionoption = '';
                this.dialogVisible = false;
            },
            //点击确认续费操作
            sure(e, e1) {
                //e 版本 e1 续费||升级
                let url = '/v1/member/user/upgrade';
                let data = {
                    vip_type: e,
                    type: e1
                };
                console.log(data);
                // return;
                auth(url, data).then(res => {
                    if (res.data.code == 1) {
                        this.getuserinfo();
                        this.dialogVisible = false;
                    } else {
                        this.$toast.fail(res.data.msg);
                    }
                })
            },
            //获取信息
            getuserinfo() {
                this.$store.dispatch('GetInfo').then(data => {
                    // console.log('成功')
                }).catch((data) => {
                    if (data.data.code == 8000) {
                        this.logout();
                        // this.loading = false;
                    } else {
                        this.$toast.fail(data);
                    }
                })
            },
            // 退出登录
            logout() {
                this.$store.dispatch('LogOut').then(data => {
                    this.$toast.success('退出成功');
                    this.$router.push({path: '/index',});
                }).catch((data) => {
                    this.$toast.fail(data.data.msg);
                })
            },

            //选购
            jumppayediton(e) {
              if (e){
                this.$router.push('/editonpurchase_mobile');
              }else{
                this.$router.push('/editionpay_mobile');
              }

            },
        },
    }
</script>

<style scoped lang='scss'>
    .editionmobile {
        width: 100%;
        height: 100%;
        background: #eee;
        position: relative;

        .topimg {
            width: 100%;
            height: 50vh;
            overflow: hidden;
            display: flex;
            justify-content: center;
            align-items: center;
            position: absolute;
            top: 0;

            img {
                height: 100%;
                width: auto;
            }
        }

        .cotain {
            position: absolute;
            top: -2rem;
            bottom: 0;
            left: 0;
            right: 0;
            margin: auto;
            width: 22rem;
            height: 28rem;
            overflow: hidden;

            .swiper-container {
                position: absolute;
                left: -13rem;
                width: 48rem;
                height: 28rem;

                .swiper-slide {
                    width: 24rem;
                    height: 28rem;
                    text-align: center;
                    font-size: 18px;
                    background: #ffffff;
                    border-radius: 8px;
                    overflow: hidden;
                    /* Center slide text vertically */
                    display: -webkit-box;
                    display: -ms-flexbox;
                    display: -webkit-flex;
                    display: flex;
                    -webkit-box-pack: center;
                    -ms-flex-pack: center;
                    -webkit-justify-content: center;
                    justify-content: center;
                    -webkit-box-align: center;
                    -ms-flex-align: center;
                    -webkit-align-items: center;
                    align-items: center;
                    transition: 300ms;
                    transform: scale(0.8);
                }

                .swiper-slide-active, .swiper-slide-duplicate-active {
                    transform: scale(1);
                    z-index: 3;
                    border-radius: 8px;

                    .unitmask {
                        display: none;
                    }
                }

            }


        }

        .swiper-pagination {
            width: 30px;
            bottom: 70px;
            left: 0;
            right: 0;
            margin: auto;
            display: flex;
            justify-content: space-between;
            z-index: 2;
        }


        /*.unit {
            width: 100%;
            height: 100%;
            font-family: "PingFang SC";
            position: relative;
            border-radius: 4px;
            border-radius: 4px;
            box-sizing: border-box;
            border: 2px solid #4EAFBE;
            background:#FCFCFC;
            display: flex;
            flex-direction: column;
            align-items: center;
            .unit1 {
                box-sizing: border-box;
                width: 100%;
                background: #4EAFBE;
                color: #fff;
                line-height: 40px;
                font-family: "PingFang SC";
                font-size: 20px;
                text-align: center;
            }
            .unit1:after{
                display: block;
                content: '';
                position: absolute;
                right: -2px;
                top: -1px;
                border: 12px solid #4EAFBE;
                border-left: 12px solid transparent;
                border-bottom: 12px solid transparent;
                border-top-right-radius: 4px;
                z-index: 9;
            }
            .unit2 {
                width: auto;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: flex-start;
                margin-top: 0.3rem;
                letter-spacing: 2px;

                .edispan2 {
                    display: flex;
                    align-items: center;
                    margin-bottom: 5px;

                    img {
                        width: 20px;
                        height: 20px;
                        margin-right: 5px;
                    }

                    span {
                        font-size: 16px;
                        line-height: 24px;
                        color: #626269;
                        font-family: "PingFang SC";
                    }


                }

            }
            .unit3 {
                font-size: 20px;
                color: #333333;
                margin: 8px 0 5px;
                font-family: "PingFang SC";
                letter-spacing: 1px;
                display: flex;
                align-items: flex-end;

                span {
                    font-size: 16px;
                    margin-bottom: 2px;
                }

            }
            .unit5 {
                color: #999999;
                font-size: 16px;
                line-height: 20px;
                font-family: "PingFang SC";
                letter-spacing: 1px;
            }
            .unit4 {
                width: 12rem;
                height: 2rem;
                border-radius: 2rem;
                margin:0.5rem auto;
                font-size: 16px;
                line-height: 2rem;
                background: #4EAFBE;
                color: #ffffff;
            }
        }
        .unitmask {
            width: 100%;
            height: 100%;
            background: #000;
            position: absolute;
            top: 0;
            left: 0;
            opacity: 0.7;
            z-index: 5;
        }
        .unitboder:before {
            display: block;
            content: '当前版本';
            position: absolute;
            right: -5px;
            top: 9px;
            z-index: 2;
            width: auto;
            font-size: 10px;
            line-height: 20px;
            font-family: "PingFang SC";
            color: #4EAFBE;
            transform: rotate(45deg);
            -webkit-transform: rotate(45deg);
            -moz-transform: rotate(45deg);
        }
        .unitboder:after {
            display: block;
            content: '';
            position: absolute;
            right: -1px;
            top: -1px;
            border: 25px solid #ffffff;
            border-left: 25px solid transparent;
            border-bottom: 25px solid transparent;
            border-top-right-radius: 4px;
        }

        .units {
            width: 100%;
            height: 100%;
            font-family: "PingFang SC";
            position: relative;
            border-radius: 4px;
            border-radius: 4px;
            box-sizing: border-box;
            border: 2px solid #4E8ABE;
            background:#FCFCFC;
            display: flex;
            flex-direction: column;
            align-items: center;


            .unit1 {
                box-sizing: border-box;
                width: 100%;
                background: #4E8ABE;
                color: #fff;
                line-height: 40px;
                font-family: "PingFang SC";
                font-size: 20px;
                text-align: center;
            }
            .unit1:after{
                display: block;
                content: '';
                position: absolute;
                right: -2px;
                top: -1px;
                border: 12px solid #4E8ABE;
                border-left: 12px solid transparent;
                border-bottom: 12px solid transparent;
                border-top-right-radius: 4px;
                z-index: 9;
            }
            .unit2 {
                width: auto;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: flex-start;
                margin-top: 0.3rem;
                letter-spacing: 2px;

                .edispan2 {
                    display: flex;
                    align-items: center;
                    margin-bottom: 5px;

                    img {
                        width: 20px;
                        height: 20px;
                        margin-right: 5px;
                    }

                    span {
                        font-size: 16px;
                        line-height: 24px;
                        color: #626269;
                        font-family: "PingFang SC";
                    }


                }

            }
            .unit3 {
                font-size: 20px;
                color: #333333;
                margin: 8px 0 5px;
                font-family: "PingFang SC";
                letter-spacing: 1px;
                display: flex;
                align-items: flex-end;

                span {
                    font-size: 16px;
                    margin-bottom: 2px;
                }

            }
            .unit5 {
                color: #999999;
                font-size: 16px;
                line-height: 20px;
                font-family: "PingFang SC";
                letter-spacing: 1px;
            }
            .unit4 {
                width: 12rem;
                height: 2rem;
                border-radius: 2rem;
                margin:0.5rem auto;
                font-size: 16px;
                line-height: 2rem;
                background: #4E8ABE;
                color: #ffffff;
            }
        }
        .unitsboder:before {
            display: block;
            content: '当前版本';
            position: absolute;
            right: -5px;
            top: 9px;
            z-index: 2;
            width: auto;
            font-size: 10px;
            line-height: 20px;
            font-family: "PingFang SC";
            color: #4E8ABE;
            transform: rotate(45deg);
            -webkit-transform: rotate(45deg);
            -moz-transform: rotate(45deg);
        }
        .unitsboder:after {
            display: block;
            content: '';
            position: absolute;
            right: -1px;
            top: -1px;
            border: 25px solid #ffffff;
            border-left: 25px solid transparent;
            border-bottom: 25px solid transparent;
            border-top-right-radius: 4px;
        }

        .unitss {
            width: 100%;
            height: 100%;
            font-family: "PingFang SC";
            position: relative;
            border-radius: 4px;
            border-radius: 4px;
            box-sizing: border-box;
            border: 2px solid #414A58;
            background:#FCFCFC;
            display: flex;
            flex-direction: column;
            align-items: center;


            .unit1 {
                box-sizing: border-box;
                width: 100%;
                background: #414A58;
                color: #fff;
                line-height: 50px;
                font-family: "PingFang SC";
                font-size: 20px;
                text-align: center;
            }
            .unit1:after{
                display: block;
                content: '';
                position: absolute;
                right: -2px;
                top: -1px;
                border: 12px solid #414A58;
                border-left: 12px solid transparent;
                border-bottom: 12px solid transparent;
                border-top-right-radius: 4px;
                z-index: 9;
            }
            .unit2 {
                width: auto;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: flex-start;
                margin-top: 0.3rem;
                letter-spacing: 2px;

                .edispan2 {
                    display: flex;
                    align-items: center;
                    margin-bottom: 5px;

                    img {
                        width: 20px;
                        height: 20px;
                        margin-right: 5px;
                    }

                    span {
                        font-size: 16px;
                        line-height: 24px;
                        color: #626269;
                        font-family: "PingFang SC";
                    }


                }

            }
            .unit3 {
                font-size: 20px;
                color: #333333;
                margin: 8px 0 5px;
                font-family: "PingFang SC";
                letter-spacing: 1px;
                display: flex;
                align-items: flex-end;

                span {
                    font-size: 16px;
                    margin-bottom: 2px;
                }

            }
            .unit5 {
                color: #999999;
                font-size: 16px;
                line-height: 20px;
                font-family: "PingFang SC";
                letter-spacing: 1px;
            }
            .unit4 {
                width: 12rem;
                height: 2rem;
                border-radius: 2rem;
                margin:0.5rem auto;
                font-size: 16px;
                line-height: 2rem;
                background: #414A58;
                color: #ffffff;
            }
        }
        .unitssboder:before {
            display: block;
            content: '当前版本';
            position: absolute;
            right: -5px;
            top: 9px;
            z-index: 2;
            width: auto;
            font-size: 10px;
            line-height: 20px;
            font-family: "PingFang SC";
            color: #414A58;
            transform: rotate(45deg);
            -webkit-transform: rotate(45deg);
            -moz-transform: rotate(45deg);
        }
        .unitssboder:after {
            display: block;
            content: '';
            position: absolute;
            right: -1px;
            top: -1px;
            border: 25px solid #ffffff;
            border-left: 25px solid transparent;
            border-bottom: 25px solid transparent;
            border-top-right-radius: 4px;
        }*/


        .change1 {
            width: 100%;
            height: 100%;
            background: #ffffff;
            border-radius: 4px;
            overflow: hidden;
            font-family: "PingFang SC";
            box-shadow: 5px 5px 10px rgba(8, 37, 57, 0.09);

            .change1s {
                width: 100%;
                height: auto;
                position: relative;

                img {
                    width: 100%;
                    height: auto;
                }

                .change1sf1 {
                    position: absolute;
                    left: 0;
                    right: 0;
                    top: 1rem;
                    font-size: 30px;
                    color: #fff;
                    opacity: 0.2;
                }

                .change1sf2 {
                    position: absolute;
                    left: 0;
                    right: 0;
                    top: 3.5rem;
                    font-size: 24px;
                    color: #fff;
                    letter-spacing: 0.03rem;
                }
            }

            .content1 {
                padding: 0.5rem 5px 0;
                height: auto;
                box-sizing: border-box;
                width: 85%;
                margin: 0 auto 0.5rem;
                display: flex;
                justify-content: space-between;
                align-items: center;

                .content11 {
                    display: flex;
                    justify-content: center;
                    align-items: flex-start;
                    flex-direction: column;
                    color: #333;

                    p {
                        font-size: 14px;
                    }

                    span {
                        font-size: 12px;
                    }
                }

                .content12 {
                    display: flex;
                    justify-content: center;
                    flex-direction: column;
                    color: #333333;

                    p {
                        font-size: 14px;
                    }

                    span {
                        font-size: 12px;
                        color: #999;
                    }
                }
            }

            .content2 {
                width: 85%;
                height: 0.02rem;
                background: #ccc;
                margin: 0 auto;
            }

            .content3 {
                width: 85%;
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 0.5rem 5px 0.5rem;
                margin: 0 auto;
                box-sizing: border-box;

                .content31 {
                    display: flex;
                    justify-content: space-between;
                    align-items: flex-start;

                    .content3s {
                        height: 1rem;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: flex-start;

                        .content3s1 {
                            font-size: 14px;
                            color: #333;
                        }

                        .content3s2 {
                            font-size: 12px;
                        }
                    }

                    i {
                        font-size: 0.2rem;
                        color: #a0de73;
                        /*  line-height: 0.28rem;*/
                        margin-left: 0.1rem;
                    }
                }

                .content32 {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;

                    .content321 {
                        color: #333;
                        font-size: 14px;
                    }

                    .content322 {
                        color: #999;
                        font-size: 12px;
                    }

                }

                .el-popover .el-popper .el-popover--plain {
                    padding: 5px !important;

                }

            }

            .content3:active {
                background: rgba(113, 125, 137, 0.1);
                border-radius: 4px;
            }

            .content3:focus {
                background: rgba(113, 125, 137, 0.1);
                border-radius: 4px;

            }


        }


        .unitmask {
            width: 100%;
            height: 100%;
            background: #000;
            position: absolute;
            top: 0;
            left: 0;
            opacity: 0.3;
            z-index: 5;
        }

        .cbuto {
            padding: 5px 10px;

            width: 100px;
            height: 32px;
            position: absolute;
            right: 0;
            left: 0;
            bottom: 60px;
            margin: auto;

        }
    }


</style>
<style lang="scss">
    .el-popover--plain {
        padding: 5px !important;
        font-size: 14px !important;
    }
</style>